import { render } from "./ReportsViewer.vue?vue&type=template&id=cb152a76"
import script from "./ReportsViewer.vue?vue&type=script&lang=js"
export * from "./ReportsViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__